const ua = window.navigator.userAgent
const msie = ua.indexOf('MSIE ')
const msie11 = ua.indexOf('Trident/')
const msedge = ua.indexOf('Edge/')
const firefox = ua.indexOf('Firefox')
const isIE = msie > 0 || msie11 > 0
const isEdge = msedge > 0
const isFirefox = firefox > 0 // Only needed if you need to support the redirect flow in Firefox incognito

const tenant = import.meta.env.VITE_ADB2C_TENANT
const authorityDomain = import.meta.env.VITE_ADB2C_AUTHORITY_DOMAIN || `${tenant}.b2clogin.com`
const acceptInvite = 'B2C_1A_INV_REDEEM'
const forgotPassword = 'B2C_1_reset_v3'
const editProfile = 'B2C_1_edit_profile_v2'
const signUpSignIn = 'B2C_1A_SIGNUP_SIGNIN_PORTAL'

export const b2cPolicies = {
  names: {
    acceptInvite: acceptInvite,
    forgotPassword: forgotPassword,
    editProfile: editProfile,
    signUpSignIn: signUpSignIn,
  },
  authorities: {
    acceptInvite: {
      authority: `https://${authorityDomain}/${tenant}.onmicrosoft.com/${acceptInvite}`,
    },
    forgotPassword: {
      authority: `https://${authorityDomain}/${tenant}.onmicrosoft.com/${forgotPassword}`,
    },
    editProfile: {
      authority: `https://${authorityDomain}/${tenant}.onmicrosoft.com/${editProfile}`,
    },
    signUpSignIn: {
      authority: `https://${authorityDomain}/${tenant}.onmicrosoft.com/${signUpSignIn}`,
    },
  },
  authorityDomain: authorityDomain,
}

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_ADB2C_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: import.meta.env.VITE_ADB2C_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
    // loggerOptions: {
    //   loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
    //     if (containsPii) {
    //       return;
    //     }
    //     switch (level) {
    //       case LogLevel.Error:
    //         console.error(message);
    //         return;
    //       case LogLevel.Info:
    //         console.info(message);
    //         return;
    //       case LogLevel.Verbose:
    //         console.debug(message);
    //         return;
    //       case LogLevel.Warning:
    //         console.warn(message);
    //         return;
    //       default:
    //         return;
    //     }
    //   },
    // },
  },
}

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `https://${tenant}.onmicrosoft.com/usermanagement/admin`,
  ],
}
